import { useTemplateContext } from "../../../../context/TemplateContext";
import React, { useState } from "react";
import { toastError, toastSuccess } from "../../../../utils/toastUtils";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import Label from "../../../../components/FormComponents/Label";
import Input from "../../../../components/FormComponents/Input";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import FieldsTable from "./FieldsTable";
import { fieldTypeOptions, isNamePresent } from "./util";
import RDBMSUpload from "./RDBMSUpload";

const RDBMSTemplateFields = () => {
  const { templateData, setTemplateData } = useTemplateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const config = templateData.fields || [];
  const initialNewField = {
    name: "",
    type: "int",
    index: null,
    sub_fields: null
  };
  const [newField, setNewField] = useState(initialNewField);
  const [error, setError] = useState("");

  const handleFieldChange = (name, value) => {
    setNewField({ ...newField, [name]: value });
    setError("");
  };

  const handleIndexChange = (e) => {
    const { name, value } = e.target;
    if (newField.type === "fk") {
      setNewField({
        ...newField,
        index: {
          ...newField.index,
          [name]: value
        }
      });
    }
  };

  const handleSetTemplateFields = (fields) => {
    setTemplateData({
      ...templateData,
      fields: fields
    });
  };

  const addField = (newFieldData) => {
    const trimmedName = newFieldData.name.trim();
    const existingField = isNamePresent(config, trimmedName);

    if (trimmedName === "") {
      setError("Name cannot be empty!");
      return;
    }

    if (existingField) {
      setError(`Field with name "${trimmedName}" already exists!`);
      return;
    }

    let newIndex = null;
    if (newFieldData.type === "fk") {
      newIndex = newFieldData.index;
    }
    if (newFieldData.type === "recordset-list") {
      newFieldData.sub_fields = [];
    }

    handleSetTemplateFields([...config, { ...newFieldData, name: trimmedName, index: newIndex }]);
    setNewField(initialNewField);
    setError("");
  };

  const handleDelete = (name) => {
    const deleteFromArray = (arr) => {
      for (let i = 0; i < arr.length; i++) {
        const field = arr[i];
        if (field.name === name) {
          arr.splice(i, 1); // Remove the element from array
          return true; // Indicates deletion and break the loop
        }
        if (field.sub_fields && field.sub_fields.length > 0) {
          if (deleteFromArray(field.sub_fields)) {
            return true; // Indicates deletion and break the loop
          }
        }
      }
      return false; // Name not found
    };

    const updatedConfig = [...config];
    if (!deleteFromArray(updatedConfig)) {
      console.log(`Name "${name}" not found in the configuration.`);
    }

    handleSetTemplateFields(updatedConfig);
  };

  const handleEdit = (name, editedField) => {
    const updateArray = (arr) => {
      for (let i = 0; i < arr.length; i++) {
        const field = arr[i];
        if (field.name === name) {
          arr[i] = { ...field, ...editedField };
          return true;
        }
        if (field.sub_fields && field.sub_fields.length > 0) {
          if (updateArray(field.sub_fields)) {
            return true;
          }
        }
      }
      return false;
    };

    const updatedConfig = [...config];
    if (!updateArray(updatedConfig)) {
      console.log(`Name "${name}" not found in the configuration.`);
    }
    handleSetTemplateFields(updatedConfig);
    setError("");
  };

  const handleAddJsonConfig = (json) => {
    try {
      const parsedJson = JSON.parse(json);
      setTemplateData({
        ...templateData,
        fields: parsedJson
      });
      setIsModalOpen(false);
    } catch (error) {
      toastError("Error parsing JSON!");
    }
  };

  const copyToClipboard = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    toastSuccess("Text copied to clipboard!");
  };

  const updateGroupMapping = (key, value) => {
    setTemplateData((prevState) => ({
      ...prevState,
      is_group_mapping: {
        ...(prevState.is_group_mapping || {}),
        [key]: value
      }
    }));
  };

  const userIdOptions = templateData.fields || [];

  return (
    <div className="builder_form">
      <div className="flex_column gap_2">
        {templateData.is_group && (
          <div className="d_flex gap_2">
            <SingleSelectBox
              valueKey={"name"}
              // labelKey={["name"]}
              selectedData={templateData?.is_group_mapping?.user_id || ""}
              options={userIdOptions}
              onChange={(obj) => updateGroupMapping("user_id", obj.name)}
              label="Select User Id"
            />
            <SingleSelectBox
              valueKey={"name"}
              // labelKey={["name"]}
              selectedData={templateData?.is_group_mapping?.group || ""}
              options={userIdOptions}
              onChange={(obj) => updateGroupMapping("group", obj.name)}
              label="Select Role"
            />
            <SingleSelectBox
              valueKey={"name"}
              // labelKey={["name"]}
              selectedData={templateData?.is_group_mapping?.instance_id || ""}
              options={userIdOptions}
              onChange={(obj) => updateGroupMapping("instance_id", obj.name)}
              label="Select Instance Id"
            />
          </div>
        )}
      </div>
      <div className="d_flex space_between" style={{ width: "525px" }}>
        <Label className="builder_label">Add New Field</Label>
      </div>
      <div className="flex_row gap_2">
        <div className="d_flex gap_2">
          <div className="flex_column gap_1">
            <Label>Name: </Label>
            <Input
              name="name"
              value={newField.name}
              onChange={(e) => handleFieldChange(e.target.name, e.target.value)}
              style={{ margin: "0" }}
            />
            {/* {error && <div style={{ color: "red" }}>{error}</div>} */}
          </div>
          <div className="flex_column gap_1">
            <Label>Type: </Label>
            <SingleSelectBox
              selectedData={newField.type}
              options={fieldTypeOptions}
              onChange={(obj) => handleFieldChange("type", obj.id)}
              placeholder="Select Type"
            />
          </div>
          {/* <div className="flex_row gap_2 align_center">
            <Button variant="secondary" type="button" onClick={() => addField(newField)}>
              Add Field
            </Button>
            <ButtonActionIcon type="content_copy" onClick={() => copyToClipboard(JSON.stringify(config, null, 2))} />
            <ButtonActionIcon type="upload" onClick={() => setIsModalOpen(true)} />
          </div> */}
          <div style={{ display: "flex", alignItems: "center", marginTop: "20px" }}>
            <ButtonActionIcon type="add" onClick={() => addField(newField)} className="mb_2" />
          </div>
        </div>
        <div className="flex_row gap_2" style={{ marginTop: "23px", marginLeft: "500px" }}>
          <ButtonActionIcon type="content_copy" onClick={() => copyToClipboard(JSON.stringify(config, null, 2))} />
          <ButtonActionIcon type="upload" onClick={() => setIsModalOpen(true)} />
        </div>
      </div>
      {error && <div style={{ color: "red" }}>{error}</div>}
      <div className="">
        {newField.type === "fk" && (
          <div className="d_flex gap_2">
            <Input
              label="Foreign Table: "
              name="f_table"
              value={newField.index?.f_table || ""}
              onChange={handleIndexChange}
            />
            <Input
              label="Instance ID: "
              name="instance_id"
              value={newField.index?.instance_id || ""}
              onChange={handleIndexChange}
            />
            <Input label="Primary Key: " name="pk" value={newField.index?.pk || ""} onChange={handleIndexChange} />
          </div>
        )}
      </div>
      <FieldsTable config={config || []} handleEdit={handleEdit} handleDelete={handleDelete} />
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Upload JSON">
        <RDBMSUpload handleAddJsonConfig={handleAddJsonConfig} />
      </BuilderModal>
    </div>
  );
};

export default RDBMSTemplateFields;
